import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environment';
import { FeatureFlagService } from '@core/services';

@Injectable({
  providedIn: 'root',
})
export class ArivoMarketingConsentService {
  constructor(
    private http: HttpClient,
    private featureFlagService: FeatureFlagService,
  ) {}

  submitMarketingAgreement(email: string) {
    if (!environment.production) {
      console.warn('Marketing agreement not submitted in development environment');
      return;
    }
    if (!this.featureFlagService.getFeatureFlag('enable_marketing_consent')) {
      return;
    }

    const url = 'https://wipark.azurefd.net/v1/marketingagreement';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // eslint-disable-next-line
      'Ocp-Apim-Subscription-Key': '06f6cca3f2fd4d67b210085b92b8b1d1', // NOSONAR
    });
    const body = { email };

    this.http.post(url, body, { headers }).subscribe({
      next: (response) => {},
      error: (error) => {},
    });
  }
}
